// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"df6d6ded","46":"01517650","51":"0b11c328","134":"1ba99ddf","195":"0af4dbda","288":"92c151fd","391":"514b4dde","623":"257adc1c","852":"8869eebd","857":"825d317e","897":"72dab0c3"}[chunkId] + ".chunk.js";
};